import { render, staticRenderFns } from "./ControlloAlloggiMenuView.vue?vue&type=template&id=26f83ca1&"
import script from "./ControlloAlloggiMenuView.vue?vue&type=script&lang=ts&"
export * from "./ControlloAlloggiMenuView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports